function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint no-nested-ternary: off */
import $ from 'dom7';
import Utils from '../../utils/utils';
import Framework7Class from '../../utils/class';

var Gauge = /*#__PURE__*/function (_Framework7Class) {
  _inherits(Gauge, _Framework7Class);

  var _super = _createSuper(Gauge);

  function Gauge(app) {
    var _this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Gauge);

    // Extends with open/close Modal methods;
    _this = _super.call(this, params, [app]);

    var gauge = _assertThisInitialized(_this);

    var defaults = Utils.extend({}, app.params.gauge); // Extend defaults with modules params

    gauge.useModulesParams(defaults);
    gauge.params = Utils.extend(defaults, params);
    var el = gauge.params.el;
    if (!el) return _possibleConstructorReturn(_this, gauge);
    var $el = $(el);
    if ($el.length === 0) return _possibleConstructorReturn(_this, gauge);
    if ($el[0].f7Gauge) return _possibleConstructorReturn(_this, $el[0].f7Gauge);
    Utils.extend(gauge, {
      app: app,
      $el: $el,
      el: $el && $el[0]
    });
    $el[0].f7Gauge = gauge; // Install Modules

    gauge.useModules();
    gauge.init();
    return _possibleConstructorReturn(_this, gauge);
  }

  _createClass(Gauge, [{
    key: "calcRadius",
    value: function calcRadius() {
      var gauge = this;
      var _gauge$params = gauge.params,
          size = _gauge$params.size,
          borderWidth = _gauge$params.borderWidth;
      return size / 2 - borderWidth / 2;
    }
  }, {
    key: "calcBorderLength",
    value: function calcBorderLength() {
      var gauge = this;
      var radius = gauge.calcRadius();
      return 2 * Math.PI * radius;
    }
  }, {
    key: "render",
    value: function render() {
      var gauge = this;
      if (gauge.params.render) return gauge.params.render.call(gauge, gauge);
      var _gauge$params2 = gauge.params,
          type = _gauge$params2.type,
          value = _gauge$params2.value,
          size = _gauge$params2.size,
          bgColor = _gauge$params2.bgColor,
          borderBgColor = _gauge$params2.borderBgColor,
          borderColor = _gauge$params2.borderColor,
          borderWidth = _gauge$params2.borderWidth,
          valueText = _gauge$params2.valueText,
          valueTextColor = _gauge$params2.valueTextColor,
          valueFontSize = _gauge$params2.valueFontSize,
          valueFontWeight = _gauge$params2.valueFontWeight,
          labelText = _gauge$params2.labelText,
          labelTextColor = _gauge$params2.labelTextColor,
          labelFontSize = _gauge$params2.labelFontSize,
          labelFontWeight = _gauge$params2.labelFontWeight;
      var semiCircle = type === 'semicircle';
      var radius = gauge.calcRadius();
      var length = gauge.calcBorderLength();
      var progress = Math.max(Math.min(value, 1), 0);
      return "\n      <svg class=\"gauge-svg\" width=\"".concat(size, "px\" height=\"").concat(semiCircle ? size / 2 : size, "px\" viewBox=\"0 0 ").concat(size, " ").concat(semiCircle ? size / 2 : size, "\">\n        ").concat(semiCircle ? "\n          <path\n            class=\"gauge-back-semi\"\n            d=\"M".concat(size - borderWidth / 2, ",").concat(size / 2, " a1,1 0 0,0 -").concat(size - borderWidth, ",0\"\n            stroke=\"").concat(borderBgColor, "\"\n            stroke-width=\"").concat(borderWidth, "\"\n            fill=\"").concat(bgColor || 'none', "\"\n          />\n          <path\n            class=\"gauge-front-semi\"\n            d=\"M").concat(size - borderWidth / 2, ",").concat(size / 2, " a1,1 0 0,0 -").concat(size - borderWidth, ",0\"\n            stroke=\"").concat(borderColor, "\"\n            stroke-width=\"").concat(borderWidth, "\"\n            stroke-dasharray=\"").concat(length / 2, "\"\n            stroke-dashoffset=\"").concat(length / 2 * (1 + progress), "\"\n            fill=\"").concat(borderBgColor ? 'none' : bgColor || 'none', "\"\n          />\n        ") : "\n          ".concat(borderBgColor ? "\n            <circle\n              class=\"gauge-back-circle\"\n              stroke=\"".concat(borderBgColor, "\"\n              stroke-width=\"").concat(borderWidth, "\"\n              fill=\"").concat(bgColor || 'none', "\"\n              cx=\"").concat(size / 2, "\"\n              cy=\"").concat(size / 2, "\"\n              r=\"").concat(radius, "\"\n            ></circle>\n          ") : '', "\n          <circle\n            class=\"gauge-front-circle\"\n            transform=\"", "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"), "\"\n            stroke=\"").concat(borderColor, "\"\n            stroke-width=\"").concat(borderWidth, "\"\n            stroke-dasharray=\"").concat(length, "\"\n            stroke-dashoffset=\"").concat(length * (1 - progress), "\"\n            fill=\"").concat(borderBgColor ? 'none' : bgColor || 'none', "\"\n            cx=\"").concat(size / 2, "\"\n            cy=\"").concat(size / 2, "\"\n            r=\"").concat(radius, "\"\n          ></circle>\n        "), "\n        ").concat(valueText ? "\n          <text\n            class=\"gauge-value-text\"\n            x=\"50%\"\n            y=\"".concat(semiCircle ? '100%' : '50%', "\"\n            font-weight=\"").concat(valueFontWeight, "\"\n            font-size=\"").concat(valueFontSize, "\"\n            fill=\"").concat(valueTextColor, "\"\n            dy=\"").concat(semiCircle ? labelText ? -labelFontSize - 15 : -5 : 0, "\"\n            text-anchor=\"middle\"\n            dominant-baseline=\"").concat(!semiCircle && 'middle', "\"\n          >").concat(valueText, "</text>\n        ") : '', "\n        ").concat(labelText ? "\n          <text\n            class=\"gauge-label-text\"\n            x=\"50%\"\n            y=\"".concat(semiCircle ? '100%' : '50%', "\"\n            font-weight=\"").concat(labelFontWeight, "\"\n            font-size=\"").concat(labelFontSize, "\"\n            fill=\"").concat(labelTextColor, "\"\n            dy=\"").concat(semiCircle ? -5 : valueText ? valueFontSize / 2 + 10 : 0, "\"\n            text-anchor=\"middle\"\n            dominant-baseline=\"").concat(!semiCircle && 'middle', "\"\n          >").concat(labelText, "</text>\n        ") : '', "\n      </svg>\n    ").trim();
    }
  }, {
    key: "update",
    value: function update() {
      var newParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var gauge = this;
      var params = gauge.params,
          $gaugeSvgEl = gauge.$gaugeSvgEl;
      Object.keys(newParams).forEach(function (param) {
        if (typeof newParams[param] !== 'undefined') {
          params[param] = newParams[param];
        }
      });
      if ($gaugeSvgEl.length === 0) return gauge;
      var value = params.value,
          size = params.size,
          bgColor = params.bgColor,
          borderBgColor = params.borderBgColor,
          borderColor = params.borderColor,
          borderWidth = params.borderWidth,
          valueText = params.valueText,
          valueTextColor = params.valueTextColor,
          valueFontSize = params.valueFontSize,
          valueFontWeight = params.valueFontWeight,
          labelText = params.labelText,
          labelTextColor = params.labelTextColor,
          labelFontSize = params.labelFontSize,
          labelFontWeight = params.labelFontWeight;
      var length = gauge.calcBorderLength();
      var progress = Math.max(Math.min(value, 1), 0);
      var radius = gauge.calcRadius();
      var semiCircle = params.type === 'semicircle';
      var svgAttrs = {
        width: "".concat(size, "px"),
        height: "".concat(semiCircle ? size / 2 : size, "px"),
        viewBox: "0 0 ".concat(size, " ").concat(semiCircle ? size / 2 : size)
      };
      Object.keys(svgAttrs).forEach(function (attr) {
        $gaugeSvgEl.attr(attr, svgAttrs[attr]);
      });

      if (semiCircle) {
        var backAttrs = {
          d: "M".concat(size - borderWidth / 2, ",").concat(size / 2, " a1,1 0 0,0 -").concat(size - borderWidth, ",0"),
          stroke: borderBgColor,
          'stroke-width': borderWidth,
          fill: bgColor || 'none'
        };
        var frontAttrs = {
          d: "M".concat(size - borderWidth / 2, ",").concat(size / 2, " a1,1 0 0,0 -").concat(size - borderWidth, ",0"),
          stroke: borderColor,
          'stroke-width': borderWidth,
          'stroke-dasharray': length / 2,
          'stroke-dashoffset': length / 2 * (1 + progress),
          fill: borderBgColor ? 'none' : bgColor || 'none'
        };
        Object.keys(backAttrs).forEach(function (attr) {
          $gaugeSvgEl.find('.gauge-back-semi').attr(attr, backAttrs[attr]);
        });
        Object.keys(frontAttrs).forEach(function (attr) {
          $gaugeSvgEl.find('.gauge-front-semi').attr(attr, frontAttrs[attr]);
        });
      } else {
        var _backAttrs = {
          stroke: borderBgColor,
          'stroke-width': borderWidth,
          fill: bgColor || 'none',
          cx: size / 2,
          cy: size / 2,
          r: radius
        };
        var _frontAttrs = {
          transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"),
          stroke: borderColor,
          'stroke-width': borderWidth,
          'stroke-dasharray': length,
          'stroke-dashoffset': length * (1 - progress),
          fill: borderBgColor ? 'none' : bgColor || 'none',
          cx: size / 2,
          cy: size / 2,
          r: radius
        };
        Object.keys(_backAttrs).forEach(function (attr) {
          $gaugeSvgEl.find('.gauge-back-circle').attr(attr, _backAttrs[attr]);
        });
        Object.keys(_frontAttrs).forEach(function (attr) {
          $gaugeSvgEl.find('.gauge-front-circle').attr(attr, _frontAttrs[attr]);
        });
      }

      if (valueText) {
        if (!$gaugeSvgEl.find('.gauge-value-text').length) {
          var textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          textEl.classList.add('gauge-value-text');
          $gaugeSvgEl.append(textEl);
        }

        var textAttrs = {
          x: '50%',
          y: semiCircle ? '100%' : '50%',
          'font-weight': valueFontWeight,
          'font-size': valueFontSize,
          fill: valueTextColor,
          dy: semiCircle ? labelText ? -labelFontSize - 15 : -5 : 0,
          'text-anchor': 'middle',
          'dominant-baseline': !semiCircle && 'middle'
        };
        Object.keys(textAttrs).forEach(function (attr) {
          $gaugeSvgEl.find('.gauge-value-text').attr(attr, textAttrs[attr]);
        });
        $gaugeSvgEl.find('.gauge-value-text').text(valueText);
      } else {
        $gaugeSvgEl.find('.gauge-value-text').remove();
      }

      if (labelText) {
        if (!$gaugeSvgEl.find('.gauge-label-text').length) {
          var _textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');

          _textEl.classList.add('gauge-label-text');

          $gaugeSvgEl.append(_textEl);
        }

        var labelAttrs = {
          x: '50%',
          y: semiCircle ? '100%' : '50%',
          'font-weight': labelFontWeight,
          'font-size': labelFontSize,
          fill: labelTextColor,
          dy: semiCircle ? -5 : valueText ? valueFontSize / 2 + 10 : 0,
          'text-anchor': 'middle',
          'dominant-baseline': !semiCircle && 'middle'
        };
        Object.keys(labelAttrs).forEach(function (attr) {
          $gaugeSvgEl.find('.gauge-label-text').attr(attr, labelAttrs[attr]);
        });
        $gaugeSvgEl.find('.gauge-label-text').text(labelText);
      } else {
        $gaugeSvgEl.find('.gauge-label-text').remove();
      }

      return gauge;
    }
  }, {
    key: "init",
    value: function init() {
      var gauge = this;
      var $gaugeSvgEl = $(gauge.render()).eq(0);
      $gaugeSvgEl.f7Gauge = gauge;
      Utils.extend(gauge, {
        $gaugeSvgEl: $gaugeSvgEl,
        gaugeSvgEl: $gaugeSvgEl && $gaugeSvgEl[0]
      });
      gauge.$el.append($gaugeSvgEl);
      return gauge;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var gauge = this;
      if (!gauge.$el || gauge.destroyed) return;
      gauge.$el.trigger('gauge:beforedestroy');
      gauge.emit('local::beforeDestroy gaugeBeforeDestroy', gauge);
      gauge.$gaugeSvgEl.remove();
      delete gauge.$el[0].f7Gauge;
      Utils.deleteProps(gauge);
      gauge.destroyed = true;
    }
  }]);

  return Gauge;
}(Framework7Class);

export default Gauge;